import { Injectable } from '@angular/core';

import { LocalStorageService } from '@main-client/src/app/core/local-storage.service';

import {
  LocaleTranslationsMap,
  UserContentTranslation,
} from '@libs/src/locale-lookup/locale-translations-map.interface';
import { locales } from '@libs/src/locale/locale.helper';
import { TranslationLookupMap } from '@libs/src/locale/locale.interface';

import merge from 'lodash-es/merge';

const translationMapKey = 'translationsMap';

@Injectable({
  providedIn: 'root',
})
export class TranslationLocalStorageService {
  constructor(private localStorageService: LocalStorageService) {}

  getEmptyTranslationsMap(): LocaleTranslationsMap {
    return locales.reduce(
      (accumulator, locale) => ({
        ...accumulator,
        [locale.code]: {},
      }),
      {},
    );
  }

  getTranslationsMap(): LocaleTranslationsMap {
    if (null === this.localStorageService.getItem(translationMapKey)) {
      return this.getEmptyTranslationsMap();
    }
    return JSON.parse(this.localStorageService.getItem(translationMapKey));
  }

  setTranslationsMap(userContentLocales: UserContentTranslation[]) {
    this.localStorageService.setItem(
      translationMapKey,
      JSON.stringify(
        merge(
          this.getTranslationsMap(),
          this.composeLocaleTranslationsMap(userContentLocales),
        ),
      ),
    );
  }

  composeLocaleTranslationsMap(userContentLocales: any): TranslationLookupMap {
    return userContentLocales.reduce(
      (result: any, unit: any) => ({
        ...result,
        [unit.locale_name]: {
          ...result[unit.locale_name],
          [unit.translation_unit]: unit.mappings,
        },
      }),
      {},
    );
  }
}
